import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class TypewriterService {
    private isRunning = true;

    async startTypewriterEffect(
        titles: string[],
        callback: (text: string) => void,
    ) {
        this.isRunning = true;
        while (this.isRunning) {
            for (const title of titles) {
                if (!this.isRunning) break;
                await this.typeEffect(title, callback);
            }
            await this.delay(1000);
        }
    }

    stop() {
        this.isRunning = false;
    }

    private async typeEffect(word: string, callback: (text: string) => void) {
        await this.typeText(word, 50, callback);
        await this.delay(1200);
        await this.deleteText(word, 30, callback);
        await this.delay(300);
    }

    private async typeText(
        word: string,
        speed: number,
        callback: (text: string) => void,
    ) {
        for (let i = 0; i < word.length; i++) {
            if (!this.isRunning) return;
            callback(word.substring(0, i + 1));
            await this.delay(speed);
        }
    }

    private async deleteText(
        word: string,
        speed: number,
        callback: (text: string) => void,
    ) {
        for (let i = word.length; i > 0; i--) {
            if (!this.isRunning) return;
            callback(word.substring(0, i - 1));
            await this.delay(speed);
        }
    }

    private delay(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}
